<!-- HEADER -->
<div class="mb-6 px-3">
  <div class="w-fit rounded-2xl border border-gray-300 bg-gradient-to-r from-gray-50 to-white px-5 py-3">
    <div class="border-l-4 border-gray-800 pl-4">
      <div class="flex items-center gap-3">

        

        <div>
          <p class="text-xs font-semibold uppercase tracking-[0.18em] text-gray-500">
            Social AI Settings
          </p>

          <h2 class="mt-1 text-2xl font-bold leading-tight tracking-tight text-gray-900">
            {{ currentTabLabel }}
          </h2>
        </div>

      </div>
    </div>
  </div>
</div>

<!-- CONTENT WRAPPER -->
<div class="min-h-screen bg-gray-50 px-3 pb-10 pt-6">

  <!-- SETTINGS CARD -->
  <div class="w-full rounded-2xl border border-gray-300 bg-white p-4">

    <mat-tab-group
      [(selectedIndex)]="selectedIndex"
      (selectedIndexChange)="onTabChange($event)"
      class="custom-tabs">

      <mat-tab *ngFor="let tab of tabs" [label]="tab.name">

        <ng-template mat-tab-label>
          <div class="flex items-center gap-2">
            <mat-icon class="!h-5 !w-5 !text-[20px]">
              {{ tab.icon }}
            </mat-icon>

            <span class="text-sm font-semibold">
              {{ tab.name }}
            </span>
          </div>
        </ng-template>

        <div class="border-t border-gray-300 pt-4">

          <ng-container *ngIf="tab.name === 'Sites' && selectedIndex === 0">
            <app-social-ai-site-table
              [companyID]="selectedCompanyId">
            </app-social-ai-site-table>
          </ng-container>

          <ng-container *ngIf="tab.name === 'Social Platforms' && selectedIndex === 1">
            <app-social-ai-platforms-table
              [companyID]="selectedCompanyId"
              [tiktokPlatformId]="tiktokPlatformId"
              [tiktokSiteId]="tiktokSiteId">
            </app-social-ai-platforms-table>
          </ng-container>

          <ng-container *ngIf="tab.name === 'Scheduler' && selectedIndex === 2">
            <app-social-ai
              [companyID]="selectedCompanyId">
            </app-social-ai>
          </ng-container>

          <ng-container *ngIf="tab.name === 'Posting Queue' && selectedIndex === 3">
            <app-social-ai-queue-table
              [companyID]="selectedCompanyId">
            </app-social-ai-queue-table>
          </ng-container>

          <ng-container *ngIf="tab.name === 'Manage Story Posts' && selectedIndex === 4">
            <app-social-ai-story-table
              [companyID]="selectedCompanyId != null ? +selectedCompanyId : 0">
            </app-social-ai-story-table>
          </ng-container>

        </div>

      </mat-tab>

    </mat-tab-group>

  </div>

</div>